import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { OrderClientRelation } from '../../../../../core';

@JsonConverter
export class OrderClientRelationAdapter implements JsonCustomConvert<OrderClientRelation | undefined> {
    serialize(relation: OrderClientRelation): any | undefined {
        return relation ? String(relation) : undefined;
    }

    deserialize(relation: any): OrderClientRelation | undefined {
        switch (relation) {
            case 'AttorneyInFact':
                return OrderClientRelation.ATTORNEY_IN_FACT;
            case 'Authorised':
                return OrderClientRelation.AUTHORISED;
            case 'Holder':
                return OrderClientRelation.TITULAR;
            case 'Tutor':
                return OrderClientRelation.TUTOR;
            default:
                return undefined;
        }
    }
}
